export default "__VITE_ASSET__CPrDty0z__"